var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58338",
    "data-name": "Group 58338",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.295,
    height: 65,
    viewBox: "0 0 56.295 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(-0.902 -196.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>",
    transform: "translate(22.118 226.14)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_",
    "data-name": "<Compound Path>",
    d: "M31.121,226.745a7.809,7.809,0,0,0-5.451,3.074,14.841,14.841,0,0,0-2.361,4.466,12.262,12.262,0,0,0-.289,6.64c.442,1.97,1.579,4.534,3.532,5.485a4.312,4.312,0,0,0,5.18-1.274c1.766-2.174,1.732-4.84,2.123-7.472a15.279,15.279,0,0,1,.832-3.108c.577-1.511,1.664-3.125,1.308-4.789a4.258,4.258,0,0,0-3.719-2.989,6.566,6.566,0,0,0-1.155-.034Z",
    transform: "translate(-22.599 -226.633)",
    fill: "#8e453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_2",
    "data-name": "<Compound Path>",
    d: "M27.821,246.41A4.035,4.035,0,0,1,26.038,246c-1.953-.934-3.142-3.481-3.6-5.553a12.529,12.529,0,0,1,.289-6.691,14.65,14.65,0,0,1,2.395-4.483,7.78,7.78,0,0,1,5.5-3.125,6.952,6.952,0,0,1,1.189.034,4.393,4.393,0,0,1,3.8,3.057,6.175,6.175,0,0,1-.832,3.753c-.17.391-.34.747-.476,1.1a16.556,16.556,0,0,0-.832,3.091c-.068.492-.119.985-.187,1.477-.255,2.191-.492,4.263-1.953,6.046A4.561,4.561,0,0,1,27.821,246.41Zm3.227-20.056H30.64a7.643,7.643,0,0,0-5.366,3.04,14.282,14.282,0,0,0-2.344,4.432,12.26,12.26,0,0,0-.289,6.572c.459,2.038,1.6,4.517,3.481,5.417a3.891,3.891,0,0,0,1.7.391,4.343,4.343,0,0,0,3.346-1.63c1.427-1.732,1.664-3.77,1.919-5.944.051-.475.119-.985.187-1.477a15.736,15.736,0,0,1,.849-3.125c.136-.374.306-.73.476-1.121a5.921,5.921,0,0,0,.815-3.617,4.2,4.2,0,0,0-3.617-2.9q-.374-.034-.747-.034Z",
    transform: "translate(-22.118 -226.14)",
    fill: "#591d00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_3",
    "data-name": "<Compound Path>",
    d: "M34.688,234.556a15.28,15.28,0,0,0-.832,3.108c-.391,2.632-.357,5.3-2.123,7.472a4.312,4.312,0,0,1-5.18,1.274c-1.953-.951-3.091-3.515-3.532-5.485a12.261,12.261,0,0,1,.289-6.64,14.842,14.842,0,0,1,2.361-4.466,7.809,7.809,0,0,1,5.451-3.074,6.565,6.565,0,0,1,1.155.034A4.258,4.258,0,0,1,36,229.767C36.352,231.432,35.265,233.045,34.688,234.556Zm-1.579-6.606c-1.494-.8-3.532-.289-4.908.509a8.762,8.762,0,0,0-2.666,2.513,10.255,10.255,0,0,0-1.579,4.364,11.1,11.1,0,0,0,.136,4.959A6.832,6.832,0,0,0,25.7,243a3.212,3.212,0,0,0,2.768.8,3.477,3.477,0,0,0,2.225-2.31,14.219,14.219,0,0,0,.645-3.872,11.421,11.421,0,0,1,1.376-4.466C33.567,231.67,35.282,229.139,33.108,227.95Z",
    transform: "translate(-22.599 -226.633)",
    fill: "#8e453c",
    fillRule: "evenodd",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M36.031,246a2.919,2.919,0,0,1-1.053,2.242,11.082,11.082,0,0,0-1.613,1.206,4.8,4.8,0,0,0-1,1.664,5.955,5.955,0,0,0,.136,4.33c.187.442-.1,1.172-.221,1.6-.187.594-.323,1.189-.543,1.766a4.674,4.674,0,0,1-1.987,2.564,3.531,3.531,0,0,1-3.244.119,6.348,6.348,0,0,1-2.479-2.615,10.89,10.89,0,0,1-1.325-4.925,13.613,13.613,0,0,0,.323,2.972c.442,1.97,1.579,4.534,3.532,5.485a4.312,4.312,0,0,0,5.18-1.274c1.766-2.174,1.732-4.84,2.123-7.472a15.279,15.279,0,0,1,.832-3.108C35.233,249.125,36.252,247.579,36.031,246Z",
    transform: "translate(-22.601 -242.627)",
    fill: "#8e453c",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(9.982 6.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M83.555,263.491c-.459.051-.815.713-1.019,1.053a6.286,6.286,0,0,0-.628,1.427,7.809,7.809,0,0,0-.221.849,7.288,7.288,0,0,0-.187,1.342c0,.289.017,1.783.662,1.274a1.985,1.985,0,0,0,.408-1.155,13.307,13.307,0,0,1,.713-2.683q.119-.306.255-.594a3.066,3.066,0,0,0,.34-.849c.034-.238,0-.7-.323-.662Z",
    transform: "translate(-81.398 -263.388)",
    fill: "#d3d9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_4",
    "data-name": "<Compound Path>",
    d: "M81.426,269.14h0a.326.326,0,0,1-.238-.1c-.306-.306-.289-1.274-.289-1.376a7.375,7.375,0,0,1,.187-1.359q.1-.459.221-.866a6.026,6.026,0,0,1,.645-1.444l.068-.136c.221-.357.56-.917,1.019-.968a.363.363,0,0,1,.323.119,1.076,1.076,0,0,1,.119.662,2.535,2.535,0,0,1-.255.679q-.051.1-.085.187c-.1.221-.187.408-.255.594a13.37,13.37,0,0,0-.713,2.666l-.034.17a1.617,1.617,0,0,1-.425,1.053.48.48,0,0,1-.289.119Zm1.664-6.046h-.034c-.34.051-.645.543-.849.883q-.051.068-.085.119a5.481,5.481,0,0,0-.611,1.41q-.119.391-.221.849a6.9,6.9,0,0,0-.187,1.308,2.347,2.347,0,0,0,.238,1.223c.034.051.051.051.085.051h0a.3.3,0,0,0,.17-.085,1.435,1.435,0,0,0,.34-.917.865.865,0,0,0,.017-.17,15.007,15.007,0,0,1,.73-2.7c.085-.187.17-.391.272-.611a1.556,1.556,0,0,1,.085-.2,2.078,2.078,0,0,0,.238-.611.761.761,0,0,0-.085-.492.114.114,0,0,0-.1-.051Z",
    transform: "translate(-80.899 -262.889)",
    fill: "#ca9f75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    d: "M86.1,263.9a8.66,8.66,0,0,0-.764,1.172,8.918,8.918,0,0,0-.645,1.817,12.35,12.35,0,0,0-.323,1.919,5.417,5.417,0,0,0-.034,1.053,1.568,1.568,0,0,0,.17-.085,1.985,1.985,0,0,0,.408-1.155,13.306,13.306,0,0,1,.713-2.683q.119-.306.255-.594a3.066,3.066,0,0,0,.34-.849A.812.812,0,0,0,86.1,263.9Z",
    transform: "translate(-73.754 -257.487)",
    fill: "#d3d9b6",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    d: "M32.107,246.957A11.4,11.4,0,0,1,34.28,243a8.9,8.9,0,0,0-2.768,4.008,10.038,10.038,0,0,0-.255,6.233A21.1,21.1,0,0,1,32.107,246.957Z",
    transform: "translate(-29.375 -240.137)",
    fill: "#8e453c",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_5",
    "data-name": "<Group>",
    transform: "translate(22.118 226.14)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_6",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_5",
    "data-name": "<Compound Path>",
    d: "M31.121,226.745a7.809,7.809,0,0,0-5.451,3.074,14.841,14.841,0,0,0-2.361,4.466,12.262,12.262,0,0,0-.289,6.64c.442,1.97,1.579,4.534,3.532,5.485a4.312,4.312,0,0,0,5.18-1.274c1.766-2.174,1.732-4.84,2.123-7.472a15.279,15.279,0,0,1,.832-3.108c.577-1.511,1.664-3.125,1.308-4.789a4.258,4.258,0,0,0-3.719-2.989,6.566,6.566,0,0,0-1.155-.034Z",
    transform: "translate(-22.599 -226.633)",
    fill: "#8e453c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_6",
    "data-name": "<Compound Path>",
    d: "M27.821,246.41A4.035,4.035,0,0,1,26.038,246c-1.953-.934-3.142-3.481-3.6-5.553a12.529,12.529,0,0,1,.289-6.691,14.65,14.65,0,0,1,2.395-4.483,7.78,7.78,0,0,1,5.5-3.125,6.952,6.952,0,0,1,1.189.034,4.393,4.393,0,0,1,3.8,3.057,6.175,6.175,0,0,1-.832,3.753c-.17.391-.34.747-.476,1.1a16.556,16.556,0,0,0-.832,3.091c-.068.492-.119.985-.187,1.477-.255,2.191-.492,4.263-1.953,6.046A4.561,4.561,0,0,1,27.821,246.41Zm3.227-20.056H30.64a7.643,7.643,0,0,0-5.366,3.04,14.282,14.282,0,0,0-2.344,4.432,12.26,12.26,0,0,0-.289,6.572c.459,2.038,1.6,4.517,3.481,5.417a3.891,3.891,0,0,0,1.7.391,4.343,4.343,0,0,0,3.346-1.63c1.427-1.732,1.664-3.77,1.919-5.944.051-.475.119-.985.187-1.477a15.736,15.736,0,0,1,.849-3.125c.136-.374.306-.73.476-1.121a5.921,5.921,0,0,0,.815-3.617,4.2,4.2,0,0,0-3.617-2.9q-.374-.034-.747-.034Z",
    transform: "translate(-22.118 -226.14)",
    fill: "#591d00",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_7",
    "data-name": "<Compound Path>",
    d: "M34.688,234.556a15.28,15.28,0,0,0-.832,3.108c-.391,2.632-.357,5.3-2.123,7.472a4.312,4.312,0,0,1-5.18,1.274c-1.953-.951-3.091-3.515-3.532-5.485a12.261,12.261,0,0,1,.289-6.64,14.842,14.842,0,0,1,2.361-4.466,7.809,7.809,0,0,1,5.451-3.074,6.565,6.565,0,0,1,1.155.034A4.258,4.258,0,0,1,36,229.767C36.352,231.432,35.265,233.045,34.688,234.556Zm-1.579-6.606c-1.494-.8-3.532-.289-4.908.509a8.762,8.762,0,0,0-2.666,2.513,10.255,10.255,0,0,0-1.579,4.364,11.1,11.1,0,0,0,.136,4.959A6.832,6.832,0,0,0,25.7,243a3.212,3.212,0,0,0,2.768.8,3.477,3.477,0,0,0,2.225-2.31,14.219,14.219,0,0,0,.645-3.872,11.421,11.421,0,0,1,1.376-4.466C33.567,231.67,35.282,229.139,33.108,227.95Z",
    transform: "translate(-22.599 -226.633)",
    fill: "#8e453c",
    fillRule: "evenodd",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_5",
    "data-name": "<Path>",
    d: "M36.031,246a2.919,2.919,0,0,1-1.053,2.242,11.082,11.082,0,0,0-1.613,1.206,4.8,4.8,0,0,0-1,1.664,5.955,5.955,0,0,0,.136,4.33c.187.442-.1,1.172-.221,1.6-.187.594-.323,1.189-.543,1.766a4.674,4.674,0,0,1-1.987,2.564,3.531,3.531,0,0,1-3.244.119,6.348,6.348,0,0,1-2.479-2.615,10.89,10.89,0,0,1-1.325-4.925,13.613,13.613,0,0,0,.323,2.972c.442,1.97,1.579,4.534,3.532,5.485a4.312,4.312,0,0,0,5.18-1.274c1.766-2.174,1.732-4.84,2.123-7.472a15.279,15.279,0,0,1,.832-3.108C35.233,249.125,36.252,247.579,36.031,246Z",
    transform: "translate(-22.601 -242.627)",
    fill: "#8e453c",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_7",
    "data-name": "<Group>",
    transform: "translate(9.982 6.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_6",
    "data-name": "<Path>",
    d: "M83.555,263.491c-.459.051-.815.713-1.019,1.053a6.286,6.286,0,0,0-.628,1.427,7.809,7.809,0,0,0-.221.849,7.288,7.288,0,0,0-.187,1.342c0,.289.017,1.783.662,1.274a1.985,1.985,0,0,0,.408-1.155,13.307,13.307,0,0,1,.713-2.683q.119-.306.255-.594a3.066,3.066,0,0,0,.34-.849c.034-.238,0-.7-.323-.662Z",
    transform: "translate(-81.398 -263.388)",
    fill: "#d3d9b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_8",
    "data-name": "<Compound Path>",
    d: "M81.426,269.14h0a.326.326,0,0,1-.238-.1c-.306-.306-.289-1.274-.289-1.376a7.375,7.375,0,0,1,.187-1.359q.1-.459.221-.866a6.026,6.026,0,0,1,.645-1.444l.068-.136c.221-.357.56-.917,1.019-.968a.363.363,0,0,1,.323.119,1.076,1.076,0,0,1,.119.662,2.535,2.535,0,0,1-.255.679q-.051.1-.085.187c-.1.221-.187.408-.255.594a13.37,13.37,0,0,0-.713,2.666l-.034.17a1.617,1.617,0,0,1-.425,1.053.48.48,0,0,1-.289.119Zm1.664-6.046h-.034c-.34.051-.645.543-.849.883q-.051.068-.085.119a5.481,5.481,0,0,0-.611,1.41q-.119.391-.221.849a6.9,6.9,0,0,0-.187,1.308,2.347,2.347,0,0,0,.238,1.223c.034.051.051.051.085.051h0a.3.3,0,0,0,.17-.085,1.435,1.435,0,0,0,.34-.917.865.865,0,0,0,.017-.17,15.007,15.007,0,0,1,.73-2.7c.085-.187.17-.391.272-.611a1.556,1.556,0,0,1,.085-.2,2.078,2.078,0,0,0,.238-.611.761.761,0,0,0-.085-.492.114.114,0,0,0-.1-.051Z",
    transform: "translate(-80.899 -262.889)",
    fill: "#ca9f75",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "_Path_7",
    "data-name": "<Path>",
    d: "M86.1,263.9a8.66,8.66,0,0,0-.764,1.172,8.918,8.918,0,0,0-.645,1.817,12.35,12.35,0,0,0-.323,1.919,5.417,5.417,0,0,0-.034,1.053,1.568,1.568,0,0,0,.17-.085,1.985,1.985,0,0,0,.408-1.155,13.306,13.306,0,0,1,.713-2.683q.119-.306.255-.594a3.066,3.066,0,0,0,.34-.849A.812.812,0,0,0,86.1,263.9Z",
    transform: "translate(-73.754 -257.487)",
    fill: "#d3d9b6",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    d: "M32.107,246.957A11.4,11.4,0,0,1,34.28,243a8.9,8.9,0,0,0-2.768,4.008,10.038,10.038,0,0,0-.255,6.233A21.1,21.1,0,0,1,32.107,246.957Z",
    transform: "translate(-29.375 -240.137)",
    fill: "#8e453c",
    opacity: 0.6,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(-1038.159 -884.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_8",
    "data-name": "<Group>",
    transform: "translate(1038.159 884.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_9",
    "data-name": "<Group>",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_10",
    "data-name": "<Group>",
    transform: "translate(0.538 14.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    d: "M1111.761,1397.523c-.486,11.937-6.353,27.248-19.955,30.8a8.088,8.088,0,0,1-5.314-.527c-.19-.091-.378-.181-.571-.258a4.182,4.182,0,0,0-3.523,0c-.193.076-.383.167-.571.258a8.087,8.087,0,0,1-5.314.527c-9.291-2.423-14.974-10.336-17.8-18.911a44.186,44.186,0,0,1-2.16-11.887c-.322-13.473,9.991-21.933,27.6-18.056,10.225-2.25,17.989-.342,22.639,4.293C1110.16,1387.1,1111.9,1391.872,1111.761,1397.523Z",
    transform: "translate(-1056.55 -1378.522)",
    fill: "#ef492e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_11",
    "data-name": "<Group>",
    transform: "translate(21.377 15.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    d: "M1781.45,1425.537a9.446,9.446,0,0,1-12.051,0s-1.3-1.727-.465-2.23c.606-.366,3.757.281,5.434.664a4.769,4.769,0,0,0,2.113,0c1.677-.383,4.829-1.03,5.434-.664C1782.749,1423.81,1781.45,1425.537,1781.45,1425.537Z",
    transform: "translate(-1768.654 -1423.198)",
    fill: "#d8301e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_12",
    "data-name": "<Group>",
    transform: "translate(4.786 19.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    d: "M1252.663,1571.263a42.415,42.415,0,0,1-5.115,18.641c-3.207,5.074-7.8,9.136-14,10.755a8.105,8.105,0,0,1-5.314-.524c-.19-.091-.377-.182-.571-.26a4.181,4.181,0,0,0-3.523,0c-.193.079-.383.17-.571.26a8.105,8.105,0,0,1-5.314.524c-8.086-2.11-13.438-8.375-16.552-15.615,15.683,13.028,36.416,3.652,44.124-10.131l0,0c3.064-5.484,4.071-11.665,1.873-17.409a15.117,15.117,0,0,1,1.788,2.128A19.2,19.2,0,0,1,1252.663,1571.263Z",
    transform: "translate(-1201.7 -1557.5)",
    fill: "#d8301e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_13",
    "data-name": "<Group>",
    transform: "translate(21.078 16.961)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    d: "M1758.97,1464.229a8.741,8.741,0,0,0,6.116,2.672,9.389,9.389,0,0,0,6.245-2.441.31.31,0,0,1,.474.389,5.54,5.54,0,0,1-1.285,1.443c-3.374,2.681-9.792,2.25-12.042-1.7A.309.309,0,0,1,1758.97,1464.229Z",
    transform: "translate(-1758.436 -1464.13)",
    fill: "#54040f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_Path_13",
    "data-name": "<Path>",
    d: "M2043.6,913.6c.187-6.871,5.215-13.476,18.237-10.07l1.188-.5C2065.346,913.584,2050.688,920.628,2043.6,913.6Z",
    transform: "translate(-2014.177 -902.082)",
    fill: "#c1c202"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_Group_14",
    "data-name": "<Group>",
    transform: "translate(29.423 0.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_14",
    "data-name": "<Path>",
    d: "M2043.6,927.573c5.519-5.674,10.652-3.9,15.908-7.808a12.859,12.859,0,0,0,2.33-2.262l1.188-.5C2065.346,927.553,2050.688,934.6,2043.6,927.573Z",
    transform: "translate(-2043.6 -917)",
    fill: "#7ba400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_15",
    "data-name": "<Group>",
    transform: "translate(28.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_9",
    "data-name": "<Compound Path>",
    d: "M2032.855,899.431a10.415,10.415,0,0,1-7.5-2.979.547.547,0,0,1-.161-.4,11.524,11.524,0,0,1,4.349-9.177c3.333-2.5,8.305-3,14.386-1.446l1.021-.43a.537.537,0,0,1,.734.38,10.388,10.388,0,0,1-1.027,7.31,12.76,12.76,0,0,1-5.1,4.981,14.134,14.134,0,0,1-6.7,1.759Zm-6.573-3.582c3.652,3.447,9.013,2.941,12.756.881,3.327-1.832,6.491-5.516,5.718-10.479l-.574.243a.539.539,0,0,1-.345.026c-5.835-1.525-10.553-1.106-13.646,1.214A10.4,10.4,0,0,0,2026.282,895.849Z",
    transform: "translate(-2025.197 -884.545)",
    fill: "#54040f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_16",
    "data-name": "<Group>",
    transform: "translate(28.875 3.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_15",
    "data-name": "<Path>",
    d: "M2025.04,1008.825c5.557-5.639,10.676-3.851,16.11-7.679a.306.306,0,0,1,.366.492,15.368,15.368,0,0,1-4.012,2.174c-2.795,1.03-5.777,1.5-8.323,3.046a15.5,15.5,0,0,0-3.368,2.716A.538.538,0,1,1,2025.04,1008.825Z",
    transform: "translate(-2024.878 -1001.087)",
    fill: "#54040f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_17",
    "data-name": "<Group>",
    transform: "translate(0 13.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_10",
    "data-name": "<Compound Path>",
    d: "M1071.87,1411.208a7.735,7.735,0,0,1-3.465-.787l-.021-.009c-.176-.085-.345-.167-.515-.234a3.652,3.652,0,0,0-3.125,0c-.173.067-.342.149-.536.243a8.611,8.611,0,0,1-5.645.571l-.041-.009c-6.3-1.645-11.565-5.973-15.229-12.51a42.689,42.689,0,0,1-5.127-18.785c-.149-6.359,2.075-11.755,6.262-15.206a19.212,19.212,0,0,1,9.25-4,33.766,33.766,0,0,1,12.627.577,33.762,33.762,0,0,1,12.627-.577,19.224,19.224,0,0,1,9.25,4c4.188,3.45,6.412,8.846,6.262,15.2v.009a42.687,42.687,0,0,1-5.127,18.785c-3.664,6.538-8.931,10.866-15.232,12.51l-.038.009A12.174,12.174,0,0,1,1071.87,1411.208Zm-5.563-2.458h.015a5.432,5.432,0,0,1,1.946.43c.2.079.4.173.582.26l.02.012a7.5,7.5,0,0,0,4.966.483c12.777-3.345,19.019-17.62,19.537-30.288.143-6.1-1.887-11.053-5.873-14.333-4.831-3.98-12.317-5.109-21.079-3.181a.5.5,0,0,1-.228,0c-8.765-1.929-16.25-.8-21.079,3.181-3.986,3.281-6.017,8.241-5.873,14.339.518,12.66,6.757,26.938,19.534,30.282a7.505,7.505,0,0,0,4.969-.483c.208-.1.4-.193.6-.275a5.475,5.475,0,0,1,1.946-.427Zm27.6-29.086h0Z",
    transform: "translate(-1038.159 -1360.125)",
    fill: "#410c12",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_18",
    "data-name": "<Group>",
    transform: "translate(0 13.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_11",
    "data-name": "<Compound Path>",
    d: "M1071.87,1411.208a7.732,7.732,0,0,1-3.465-.787l-.021-.009c-.176-.085-.345-.167-.515-.234a3.653,3.653,0,0,0-3.125,0c-.173.067-.342.149-.536.243a8.611,8.611,0,0,1-5.645.571.308.308,0,0,0-.041-.009c-11.258-2.938-16.215-13.33-18.17-19.262a44.851,44.851,0,0,1-2.186-12.033c-.149-6.359,2.075-11.755,6.262-15.206a19.212,19.212,0,0,1,9.25-4,33.769,33.769,0,0,1,12.627.576c9.815-2.136,17.989-.553,23.019,4.463,3.488,3.468,5.259,8.364,5.121,14.158v.009a42.686,42.686,0,0,1-5.127,18.785c-3.664,6.538-8.931,10.866-15.232,12.51l-.038.009A12.184,12.184,0,0,1,1071.87,1411.208Zm-5.563-2.458h.015a5.432,5.432,0,0,1,1.946.43c.2.079.4.173.582.26l.02.012a7.5,7.5,0,0,0,4.966.483c12.777-3.345,19.019-17.62,19.537-30.288.129-5.487-1.533-10.108-4.805-13.365-4.785-4.767-12.648-6.239-22.147-4.15a.5.5,0,0,1-.228,0c-8.765-1.928-16.25-.8-21.079,3.181-3.986,3.281-6.017,8.241-5.873,14.339a43.864,43.864,0,0,0,2.133,11.732c1.885,5.721,6.649,15.735,17.4,18.55a7.505,7.505,0,0,0,4.969-.483c.208-.1.4-.193.6-.275a5.475,5.475,0,0,1,1.946-.427Zm27.6-29.085h0Z",
    transform: "translate(-1038.159 -1360.126)",
    fill: "#54040f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_19",
    "data-name": "<Group>",
    transform: "translate(2.647 18.757)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_16",
    "data-name": "<Path>",
    d: "M1139.444,1537.094c-4.179,2.689-4.855,8.361-7.158,7.922-4.284-.814-4.711-7.316-1.923-12.709s8.185-8.144,12.057-6.145S1145.08,1533.469,1139.444,1537.094Z",
    transform: "translate(-1128.599 -1525.509)",
    fill: "#feadac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_20",
    "data-name": "<Group>",
    transform: "translate(32.501 1.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_17",
    "data-name": "<Path>",
    d: "M2157.371,938.158c.436,1.059-1.829,1.624-4.065,2.815s-4.118,2.16-4.489,1.463.957-2.388,3.193-3.579S2157.073,937.426,2157.371,938.158Z",
    transform: "translate(-2148.755 -937.743)",
    fill: "#e6e9a4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_21",
    "data-name": "<Group>",
    transform: "translate(21.366 3.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_18",
    "data-name": "<Path>",
    d: "M1771.426,1004.969c-1.372-.152-3.88,2.224-2.956,4.115,4.346,2.42,5.964,6.754,5.3,12.578a9.212,9.212,0,0,0,1.8.012C1777.162,1017.439,1777.323,1007.828,1771.426,1004.969Z",
    transform: "translate(-1768.271 -1004.962)",
    fill: "#a04618"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_22",
    "data-name": "<Group>",
    transform: "translate(26.871 7.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_19",
    "data-name": "<Path>",
    d: "M1956.514,1148.2c1.589,1.065,2.142-1.744,1.375-9.505a19.106,19.106,0,0,1,.3,12.8,5.32,5.32,0,0,1-1.791-.073Z",
    transform: "translate(-1956.4 -1138.7)",
    fill: "#87300a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_23",
    "data-name": "<Group>",
    transform: "translate(21.311 3.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_20",
    "data-name": "<Path>",
    d: "M1769.6,1005.124c2.493,1.4-1.367,5.411-2.956,4.115-1.062-1.6,1.446-4.205,2.956-4.115Z",
    transform: "translate(-1766.394 -1005.121)",
    fill: "#c97b59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_24",
    "data-name": "<Group>",
    transform: "translate(20.831 2.987)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Path_12",
    "data-name": "<Compound Path>",
    d: "M1756.918,1004.452a8.508,8.508,0,0,1-.972-.056.536.536,0,0,1-.471-.594c.658-5.768-1.03-9.821-5.025-12.048a.546.546,0,0,1-.222-.231,3.008,3.008,0,0,1,.433-3.079,3.857,3.857,0,0,1,3.064-1.806.526.526,0,0,1,.176.05c3.506,1.7,4.75,5.417,5.177,8.238a19.69,19.69,0,0,1-.767,9.139.539.539,0,0,1-.459.345C1757.524,1004.438,1757.214,1004.452,1756.918,1004.452Zm-.319-1.083c.257.012.53.009.819-.006,1.451-4.284,1.378-13.005-3.892-15.659a3.048,3.048,0,0,0-1.984,1.361,2.1,2.1,0,0,0-.41,1.844C1755.3,993.306,1757.135,997.5,1756.6,1003.369Z",
    transform: "translate(-1749.976 -986.628)",
    fill: "#54040f",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.e39f1d7d62f32cbf403c5177dce4230f.svg";
export { ForwardRef as ReactComponent };